<template>
    <div class="container">
        <online-tabs></online-tabs>
        <div class="bg_fff mt20">
            <online-table :list="list" @showRecord="getRecord"></online-table>
        </div>
        <add-medical-record :inputDisabled="true" ref="addRecord"
                            v-if="orderInfo" :datas="orderInfo"></add-medical-record>
    </div>
</template>

<script>
  import OnlineTabs from "../../components/online/tabs";
  import {mapState} from 'vuex'
  import {isEmpty, timeFormat} from "../../lib/utils";
  import {onlineService} from "../../lib/service/online";
  import OnlineTable from "../../components/online/table";
  import AddMedicalRecord from "../../components/online/add-medical-record";

  export default {
    name: "History",
    data() {
      return {
        list: [],
        orderInfo:{}
      }
    },
    computed: {
      ...mapState(['currUserBookDoc'])
    },
    components: {AddMedicalRecord, OnlineTable, OnlineTabs},
    created() {
      if (isEmpty(this.currUserBookDoc)) {
        this.$router.replace('/main/online');
      } else {
        this.getList();
      }
    },
    methods: {
      async getRecord(data){
        let {code , obj} = await this.$http("smarthos.online.outpatient.medical.info", {id: data.ddid})
        if (code ==='0'){
            this.orderInfo = Object.assign({}, obj, data)
        }
        this.$refs.addRecord.show()
      },

      async getList() {
        let {currUserBookDoc} = this, now = Date.now(), f = '%Y-%m-%d', delta = 24 * 3600 * 1000;
        const {obj} = await onlineService.list({
          hosid: currUserBookDoc.bookHosId,
          ysid: currUserBookDoc.bookDocId,
          ksid: currUserBookDoc.bookDeptId,
          edate: timeFormat(now, f),
          // edate: timeFormat(now - 1 * delta, f)
        });
        if (obj.code === '0') {
          this.list = obj.list;
        }
      }
    },
  }
</script>

<style scoped>

</style>
